/**
 * @generated SignedSource<<7ba72bc7378c9fe6d821b7b26dc54e2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignMailingListToMarketingEmailInput = {
  id: string;
  mailingListIdentifier?: string | null | undefined;
};
export type MarketingEmailDetailsViewAssignMailingListMutation$variables = {
  input: AssignMailingListToMarketingEmailInput;
};
export type MarketingEmailDetailsViewAssignMailingListMutation$data = {
  readonly assignMailingListToMarketingEmail: {
    readonly id: string;
    readonly mailingList: {
      readonly id: string;
      readonly mailingListIdentifier: string;
      readonly name: string;
      readonly subscribedCount: number;
    } | null | undefined;
    readonly recipientCount: number;
  };
};
export type MarketingEmailDetailsViewAssignMailingListMutation = {
  response: MarketingEmailDetailsViewAssignMailingListMutation$data;
  variables: MarketingEmailDetailsViewAssignMailingListMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarketingEmail",
    "kind": "LinkedField",
    "name": "assignMailingListToMarketingEmail",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "MailingList",
        "kind": "LinkedField",
        "name": "mailingList",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mailingListIdentifier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subscribedCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recipientCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarketingEmailDetailsViewAssignMailingListMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarketingEmailDetailsViewAssignMailingListMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e71cb6ef79206ffbece332de15a1f4d5",
    "id": null,
    "metadata": {},
    "name": "MarketingEmailDetailsViewAssignMailingListMutation",
    "operationKind": "mutation",
    "text": "mutation MarketingEmailDetailsViewAssignMailingListMutation(\n  $input: AssignMailingListToMarketingEmailInput!\n) {\n  assignMailingListToMarketingEmail(input: $input) {\n    id\n    mailingList {\n      id\n      mailingListIdentifier\n      name\n      subscribedCount\n    }\n    recipientCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "00de354dc4c6826a156e3e3547ef7a2b";

export default node;
